import React from "react";
import { connect } from "react-redux";
import { ratePost } from "../../../../actions";
import RatingStars from "./components/RatingStars";
import "./index.css";

const RatingBar = ({ post, actions }) => {
  return (
    <div className="ratingbar">
      {!post.userRating || post.isRatingPending ? (
        <div className="gray-area">
          <RatingStars post={post} ratePost={actions.ratePost} />
        </div>
      ) : (
        post.isJustRated && <div className="thanksmsg gray-area">Thanks!</div>
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  actions: {
    ratePost: ({ postId, rating }) => dispatch(ratePost({ postId, rating })),
  },
});

export default connect(null, mapDispatchToProps)(RatingBar);



// WEBPACK FOOTER //
// ./src/components/Post/Components/RatingBar/index.js